import type { ReviewFormData, ReviewRecord } from "@/types";

export function reviewToFormData(review: ReviewRecord): ReviewFormData {
  return {
    backgroundInfo: review.background_info || "",
    agentInstructions: review.agent_instructions || "",
    contractType: review.contract_type || "",
    jurisdiction: review.jurisdiction || "",
    userRole: review.user_role || "",
    roleInstructions: "",
    skipResearch: review.skip_research !== false,
    supportingDocs: [],
  };
}
